"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerStyled = exports.ContactTextStyled = exports.ContactSectionHeadStyled = exports.ContactSectionContentStyled = exports.ContactSectionIconStyled = exports.ContactSectionStyled = exports.ImageViewRowStyled = exports.ImageViewContentStyled = exports.ImageWrap = exports.ModalBodyStyled = exports.ModalHeaderStyled = exports.ModalStyled = exports.StyledBox = exports.Headline3Styled = exports.Headline2ImageStyled = exports.Headline2Styled = exports.Headline1Styled = void 0;

var _container = require("@dbi-tools/ui-kit/lib/components/container");

var _modal = require("@dbi-tools/ui-kit/lib/modal");

var _uiKit = require("@dbi-tools/ui-kit");

var _styled = require("../../styled");

var _helpers = require("./helpers");

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 27px;\n  ", " {\n    padding: 0 24px;\n    max-width: 800px;\n  }\n  ", " {\n    ", " {\n      font-size: 16px;\n      line-height: 24px;\n    }\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: ", ";\n  margin: 0 0 5px;\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: ", ";\n  margin: 0 0 5px;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: ", ";\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  min-width: 20px;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", " {\n    ", ";\n  }\n  ", " {\n    ", ";\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n\n  ", " {\n    max-width: 524px;\n    margin: 0 auto;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  padding: 30px 60px;\n  ", ";\n\n  ", " {\n    margin-bottom: 12px;\n  }\n\n  ", " {\n    padding: 30px;\n  }\n  ", " {\n    text-align: center;\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        height: auto;\n        padding-top: 66.6%;\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        height: auto;\n        padding-top: 66.6%;\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n  width: 100%;\n  background: #f6f6f6;\n\n  ", " {\n    ", ";\n  }\n\n  ", " {\n    ", ";\n  }\n\n  img {\n    height: 100%;\n    left: 0;\n    object-fit: cover;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  max-width: 100%;\n  padding: 30px;\n\n  ", " {\n    padding: 20px;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  padding: 22px 100px 22px 30px;\n  max-width: 100%;\n  p {\n    text-align: left;\n    margin: 0;\n    font-size: 24px;\n    line-height: 36px;\n  }\n\n  ", " {\n    p {\n      font-size: 18px;\n      line-height: 27px;\n    }\n  }\n\n  button {\n    padding: 22px 33px;\n    color: ", ";\n    ", ";\n    background: transparent;\n    svg {\n      height: 30px !important;\n      * {\n        fill: currentColor !important;\n      }\n    }\n  }\n\n  ", ";\n\n  ", " {\n    padding-left: 20px;\n    button {\n      padding: 20px;\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 30px;\n  background: rgba(255, 255, 255, 0.8);\n\n  ", " {\n    display: block;\n    padding: 30px 24px;\n  }\n\n  ", " {\n    max-width: 900px;\n    box-shadow: 3px 3px 25px -5px rgba(19, 33, 34, 0.15);\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n  & > img {\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 27px;\n  margin: 0;\n\n  ", " {\n    font-size: 14px;\n    line-height: 21px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 12px;\n  ", " {\n    margin-bottom: 15px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", " {\n    margin-bottom: 15px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  margin-bottom: -12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Headline1Styled = (0, _uiKit.styled)("h2")(_templateObject(), _styled.Line1Styles);
exports.Headline1Styled = Headline1Styled;
var Headline2Styled = (0, _uiKit.styled)("h3")(_templateObject2(), _styled.Line2Styles, _uiKit.GridBreakpointsMediaDown.md);
exports.Headline2Styled = Headline2Styled;
var Headline2ImageStyled = (0, _uiKit.styled)(Headline2Styled)(_templateObject3(), _uiKit.GridBreakpointsMediaDown.lg);
exports.Headline2ImageStyled = Headline2ImageStyled;
var Headline3Styled = (0, _uiKit.styled)("h5")(_templateObject4(), _uiKit.GridBreakpointsMediaDown.lg);
exports.Headline3Styled = Headline3Styled;
var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject5(), function (_ref) {
  var _ref$theme = _ref.theme,
      $theme = _ref$theme.$theme,
      $isAltTheme = _ref$theme.$isAltTheme,
      $isImageLayout = _ref$theme.$isImageLayout;
  return $theme && (0, _helpers.getBg)(($isAltTheme || !$isImageLayout) && $theme);
});
exports.StyledBox = StyledBox;
var ModalStyled = (0, _uiKit.styled)(_modal.Modal)(_templateObject6(), _uiKit.GridBreakpointsMediaDown.md, _modal.Dialog);
exports.ModalStyled = ModalStyled;
var ModalHeaderStyled = (0, _uiKit.styled)(_modal.Modal.Header)(_templateObject7(), _uiKit.GridBreakpointsMediaDown.lg, _uiKit.Colors.gray800, function (_ref2) {
  var $theme = _ref2.theme.$theme;
  return $theme && (0, _helpers.getBg)($theme);
}, function (_ref3) {
  var $theme = _ref3.theme.$theme;
  return $theme && (0, _helpers.getBg)($theme);
}, _uiKit.GridBreakpointsMediaDown.lg);
exports.ModalHeaderStyled = ModalHeaderStyled;
var ModalBodyStyled = (0, _uiKit.styled)(_modal.Modal.Body)(_templateObject8(), _uiKit.GridBreakpointsMediaDown.lg);
exports.ModalBodyStyled = ModalBodyStyled;
var ImageWrap = (0, _uiKit.styled)(_uiKit.Box)(_templateObject9(), _uiKit.GridBreakpointsMediaDown.lg, function (_ref4) {
  var isFullOnSize = _ref4.isFullOnSize;
  return isFullOnSize === 'table' && (0, _uiKit.css)(_templateObject10());
}, _uiKit.GridBreakpointsMediaDown.lg, function (_ref5) {
  var isFullOnSize = _ref5.isFullOnSize;
  return isFullOnSize === 'mobile' && (0, _uiKit.css)(_templateObject11());
});
exports.ImageWrap = ImageWrap;
var ImageViewContentStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject12(), function (_ref6) {
  var _ref6$theme = _ref6.theme,
      $theme = _ref6$theme.$theme,
      $isAltTheme = _ref6$theme.$isAltTheme;
  return $theme && (0, _helpers.getBg)(!$isAltTheme && $theme);
}, Headline2Styled, _uiKit.GridBreakpointsMediaDown.xl, _uiKit.GridBreakpointsMediaDown.lg);
exports.ImageViewContentStyled = ImageViewContentStyled;
var ImageViewRowStyled = (0, _uiKit.styled)(_uiKit.Row)(_templateObject13(), _uiKit.GridBreakpointsMediaDown.lg);
exports.ImageViewRowStyled = ImageViewRowStyled;
var ContactSectionStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject14(), _uiKit.GridBreakpointsMediaDown.lg, function (_ref7) {
  var centeredOnSize = _ref7.centeredOnSize;
  return centeredOnSize === 'tablet' && 'justify-content: center;';
}, _uiKit.GridBreakpointsMediaDown.md, function (_ref8) {
  var centeredOnSize = _ref8.centeredOnSize;
  return centeredOnSize === 'mobile' && 'justify-content: center;';
});
exports.ContactSectionStyled = ContactSectionStyled;
var ContactSectionIconStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject15());
exports.ContactSectionIconStyled = ContactSectionIconStyled;
var ContactSectionContentStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject16(), _uiKit.FontWeightValue.thin);
exports.ContactSectionContentStyled = ContactSectionContentStyled;
var ContactSectionHeadStyled = (0, _uiKit.styled)('h6')(_templateObject17(), _uiKit.FontWeightValue.bold);
exports.ContactSectionHeadStyled = ContactSectionHeadStyled;
var ContactTextStyled = (0, _uiKit.styled)('p')(_templateObject18(), _uiKit.FontWeightValue.thin);
exports.ContactTextStyled = ContactTextStyled;
var ContainerStyled = (0, _uiKit.styled)(_container.Container)(_templateObject19(), _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaUp.lg, ContactSectionContentStyled);
exports.ContainerStyled = ContainerStyled;